module.exports = __webpack_public_path__ + "static/media/growver.0d54bc35.png";